import type { Company } from '../types/company';
import type { CompanyInstance } from '../types/companyInstance';

/** Row from GET /users/{userId}/companies (companies.* + instance join fields). */
export interface UserCompanyApiRow {
  id: string;
  name: string;
  description?: string | null;
  industry?: string | null;
  size?: string | null;
  kryspace_slug?: string | null;
  kryspace_metadata?: string | Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
  instance_id?: string;
  instance_name?: string | null;
  user_active?: boolean | null;
  joined_at?: string | null;
}

export function mapUserCompaniesFromApi(
  userId: string,
  rows: UserCompanyApiRow[]
): Array<{ instance: CompanyInstance; company: Company }> {
  return rows
    .filter((row) => Boolean(row.id))
    .map((row) => {
      const company: Company = {
        id: row.id,
        name: row.name,
        description: row.description ?? undefined,
        industry: row.industry ?? undefined,
        size: row.size ?? undefined,
        kryspace_slug: row.kryspace_slug ?? undefined,
        is_active: row.user_active ?? true,
        created_at: row.created_at,
        updated_at: row.updated_at,
      };

      const instance: CompanyInstance = {
        id: row.instance_id ?? `${row.id}-${userId}`,
        company_id: row.id,
        user_id: userId,
        instance_name: row.instance_name ?? 'default',
        is_active: row.user_active ?? true,
        joined_at: row.joined_at ?? undefined,
        created_at: row.joined_at ?? row.created_at,
        updated_at: row.updated_at,
      };

      return { company, instance };
    });
}
